import heroImage from "../assets/shooting-range-hero.webp";
import logoImage from "../assets/omega-logo.webp";
import michalisImage from "../../Images/michalis.png";
import sotirisImage from "../../Images/Sotiris.png";
import editorialImage from "../assets/editorial-range.webp";

export type NavigationItem = {
  label: string;
  path: string;
};

export type Trainer = {
  name: string;
  certification: string;
  image: string;
  imageAlt: string;
};

export type Location = {
  title: string;
  details: string[];
  directionsUrl: string;
  embedUrl: string;
  mapTitle: string;
};

export type FaqItem = {
  question: string;
  answer: string;
};

export type ClubDocument = {
  title: string;
  fileUrl?: string;
};

export type SportDiscipline = {
  title: string;
  calibre: string;
  facts: string[];
  description: string;
};

export type SportCategory = {
  title: string;
  label: string;
  disciplines: SportDiscipline[];
};

export const assets = {
  logo: logoImage,
  hero: heroImage,
  editorial: editorialImage,
};

export const navigation: NavigationItem[] = [
  { label: "Ο Σύλλογος", path: "/o-syllogos" },
  { label: "Το Άθλημα", path: "/to-athlima" },
  { label: "Τοποθεσίες", path: "/topothesies" },
  { label: "Εκπαιδευτές", path: "/ekpaideftes" },
  { label: "Ερωτήσεις", path: "/erotiseis" },
  { label: "Έγγραφα", path: "/eggrafa" },
  { label: "Επικοινωνία", path: "/epikoinonia" },
];

// Add each supplied file to public/documents and set its fileUrl here.
export const clubDocuments: ClubDocument[] = [
  { title: "Νέα εγγραφή στο Σύλλογο" },
  { title: "Ανανέωση συνδρομής" },
  { title: "Αίτηση μεταγραφής στο Σύλλογο" },
  { title: "Έκδοση προσωρινού ΔΑΙ" },
  { title: "Χορήγηση σκοπευτικού όπλου" },
  { title: "Ετήσια θεώρηση άδειας κατοχής σκοπευτικών όπλων" },
];

export const hero = {
  title: "Αθλητικός Σκοπευτικός Όμιλος Ωμέγα",
  text: "Ο ΑΣΟ Ωμέγα ιδρύθηκε το 2006 με κύριο στόχο την προώθηση της Αθλητικής Σκοποβολής και τη δυνατότητα σε φίλους του αθλήματος να γνωρίσουν και να ασχοληθούν με ένα από τα αρχαιότερα αθλήματα.",
  cta: "Επικοινωνήστε μαζί μας",
};

export const aboutParagraphs = [
  "Ο Αθλητικός Σκοπευτικός Όμιλος (ΑΣΟ) Ωμέγα ιδρύθηκε το 2006, με κύριο στόχο την προώθηση της Αθλητικής Σκοποβολής, κάνοντας εφικτή την επιθυμία πολλών φίλων να ασχοληθούν με ένα από τα αρχαιότερα αθλήματα.",
  "Είναι μέλος της Σκοπευτικής Ομοσπονδίας Ελλάδος – ΣΚ.Ο.Ε., του επίσημου αθλητικού οργάνου της Γενικής Γραμματείας Αθλητισμού για τη Σκοποβολή, με αριθμό αναγνώρισης ΦΙ04.",
  "Υποστηρίζει αγωνίσματα για πυροβόλα όπλα — πιστόλια, περίστροφα και τυφέκια — και συμμετέχει σε επίσημους αγώνες που διοργανώνει η ΣΚ.Ο.Ε. σε όλη την Ελλάδα.",
  "Ο Όμιλος διαθέτει πιστοποιημένους από τη ΣΚΟΕ εκπαιδευτές, με μεγάλη εμπειρία σε ραβδωτά πιστόλια και τυφέκια μεγάλης εμβέλειας.",
];

export const facts = [
  { label: "Έτος ίδρυσης", value: "2006" },
  { label: "Μέλος", value: "ΣΚ.Ο.Ε." },
  { label: "Αριθμός αναγνώρισης", value: "ΦΙ04" },
];

const googleMapsPlaceEmbed = (placeName: string, zoom: number) =>
  `https://www.google.com/maps?hl=el&q=${encodeURIComponent(placeName)}&z=${zoom}&iwloc=B&output=embed`;

export const locations: Location[] = [
  {
    title: "ΠΕΔΙΟ ΒΟΛΗΣ",
    details: [
      "5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
      "Σάββατο & Κυριακή, ωράριο 09:30 - 13:30",
    ],
    directionsUrl: "https://maps.app.goo.gl/YqW9zmsVzcfNLsRHA",
    embedUrl: googleMapsPlaceEmbed(
      "ΩΜΕΓΑ ΣΚΟΠΕΥΤΙΚΟΣ ΟΜΙΛΟΣ, 5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
      15,
    ),
    mapTitle: "Χάρτης — Σκοπευτήριο Αθήνα, 5ο Πεδίο Βολής ΚΕΒΟΠ Χαϊδαρίου",
  },
  {
    title: "Γραφεία Συλλόγου",
    details: [],
    directionsUrl: "https://maps.app.goo.gl/uBKykaHx9a93ZUFe9",
    embedUrl: googleMapsPlaceEmbed("Σκοπευτικος Συλλογος Ηλιουπολης ΩΜΕΓΑ", 16),
    mapTitle: "Χάρτης — Γραφεία ΑΣΟ Ωμέγα στην Ηλιούπολη",
  },
];

export const trainers: Trainer[] = [
  {
    name: "Μιχάλης Ιωάννου",
    certification: "Πιστοποιημένος ΣΚΟΕ",
    image: michalisImage,
    imageAlt: "Μιχάλης Ιωάννου, πιστοποιημένος εκπαιδευτής σκοποβολής ΣΚΟΕ στον ΑΣΟ Ωμέγα",
  },
  {
    name: "Σωτήρης Γιανναρόπουλος",
    certification: "Πιστοποιημένος ΣΚΟΕ",
    image: sotirisImage,
    imageAlt: "Σωτήρης Γιανναρόπουλος, πιστοποιημένος εκπαιδευτής σκοποβολής ΣΚΟΕ στον ΑΣΟ Ωμέγα",
  },
];

export const faqItems: FaqItem[] = [
  {
    question: "Μπορώ να γραφτώ στον σύλλογο;",
    answer:
      "Στον ΑΣΟ Ωμέγα μπορεί να γίνει μέλος οποιοσδήποτε επιθυμεί να ασχοληθεί με το άθλημα, ανεξαρτήτως ηλικίας και φύλου.",
  },
  {
    question: "Χρειάζομαι δικό μου εξοπλισμό για την προπόνηση;",
    answer:
      "Ο Όμιλος διαθέτει μεγάλη ποικιλία όπλων και πυρομαχικών κάθε διαμετρήματος για τους αθλητές που δεν διαθέτουν δικά τους όπλα. Κατά την προπόνηση παρέχει επίσης μέσα ατομικής προστασίας, όπως ωτοασπίδες και γυαλιά.",
  },
  {
    question: "Δεν έχω εμπειρία στη σκοποβολή. Είναι δύσκολο;",
    answer:
      "Οι πιστοποιημένοι από τη ΣΚΟΕ εκπαιδευτές μας διαθέτουν εμπειρία δεκαετιών στο άθλημα. Προσφέρουμε μαθήματα όλων των βαθμίδων, σε αρχάριους και έμπειρους σκοπευτές. Στα πρώτα σας βήματα Θα σας μάθουμε κανόνες ασφαλείας, την σωστή χρήση των όπλων και τους κανονισμούς των αθλημάτων.",
  },
  {
    question: "Πότε μπορώ να κάνω προπόνηση;",
    answer:
      "Τα μέλη του συλλόγου μας συγκεντρώνονται για προπόνηση και αγώνες στο 5ο Πεδίο Βολής, στο σκοπευτήριο Χαϊδαρίου, κάθε Σάββατο και Κυριακή από τις 09:30 έως τις 13:30. Μπορείτε να έρθετε οποιαδήποτε ώρα σας εξυπηρετεί, χωρίς υποχρέωση να ακολουθείτε το πρόγραμμα των άλλων αθλητών.",
  },
  {
    question: "Μπορώ να δοκιμάσω για να δω αν μου αρέσει;",
    answer:
      "Κατόπιν συνεννόησης, μπορείτε να γνωρίσετε το άθλημα της σκοποβολής από κοντά, χωρίς να είστε εγγεγραμμένοι στον Όμιλό μας. Θα χρειαστεί μόνο να σας εκδώσουμε προσωρινή άδεια διάρκειας 2 ημερών.",
  },
];

export const sportCategories: SportCategory[] = [
  {
    title: "Πιστόλι ISSF",
    label: "Κατά σειρά διαμετρήματος",
    disciplines: [
      {
        title: "Πιστόλι Στάνταρ 25μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["25 μέτρα", ".22 LR", "60 βολές"],
        description:
          "Διεξάγεται σε σταθερό στόχο 25 μέτρων, με πιστόλι διαμετρήματος .22 LR και ελάχιστο βάρος σκανδάλης 1.000 γραμμαρίων. Περιλαμβάνει 60 βολές, χωρισμένες σε τρία στάδια των 20 βολών (τέσσερις σειρές των 5 βολών το καθένα), με φθίνοντα όρια χρόνου ανά σειρά: 150, 20 και 10 δευτερόλεπτα αντίστοιχα.",
      },
      {
        title: "Ελεύθερο Πιστόλι 50μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["50 μέτρα", ".22 LR", "60 βολές"],
        description:
          "Ο στόχος βρίσκεται στα 50 μέτρα και το αγώνισμα περιλαμβάνει 60 βολές με πιστόλι .22 LR. Η βολή εκτελείται από όρθια στάση, με το ένα χέρι και χωρίς καμία στήριξη. Ο χαρακτηρισμός «ελεύθερο» οφείλεται στο ότι δεν υπάρχουν περιορισμοί στο βάρος της σκανδάλης, στις διαστάσεις ή στο βάρος του όπλου. Ο χρόνος του αγώνα είναι 1 ώρα και 30 λεπτά (1 ώρα και 45 λεπτά χωρίς ηλεκτρονικούς στόχους), μετά από 15 λεπτά προετοιμασίας και δοκιμαστικών βολών.",
      },
      {
        title: "Πιστόλι Ταχύτητας 25μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["25 μέτρα", ".22 LR", "Ολυμπιακό"],
        description:
          "Διεξάγεται στα 25 μέτρα με πιστόλι .22 LR. Ο σκοπευτής εκτελεί 60 βολές σε δύο στάδια των 30 βολών. Κάθε στάδιο αποτελείται από έξι σειρές των 5 βολών, σε πέντε ξεχωριστούς διπλανούς στόχους: δύο σειρές στα 8, δύο στα 6 και δύο στα 4 δευτερόλεπτα. Πρόκειται για ολυμπιακό αγώνισμα.",
      },
      {
        title: "Πιστόλι Σπορ 25μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["25 μέτρα", ".22 LR", "60 βολές"],
        description:
          "Διεξάγεται στα 25 μέτρα με πιστόλι διαμετρήματος .22 LR και αποτελείται από 60 βολές, χωρισμένες σε δύο στάδια των 30 βολών. Στο Στάδιο Ακριβείας ο αθλητής εκτελεί έξι σειρές των 5 βολών, με 5 λεπτά για κάθε σειρά. Στο Στάδιο Ταχύτητας ακολουθούν έξι σειρές των 5 βολών, με εμφάνιση του στόχου για 3 δευτερόλεπτα σε κάθε βολή. Το αγώνισμα συνδυάζει έλεγχο και γρήγορη αντίδραση και σε διεθνές επίπεδο αποτελεί το ολυμπιακό αγώνισμα πιστολιού των γυναικών.",
      },
      {
        title: "Πιστόλι Κεντρικής Πυροδότησης 25μ.",
        calibre: "Μεγάλου διαμετρήματος",
        facts: ["25 μέτρα", "7,62–9,65 mm", "60 βολές"],
        description:
          "Διεξάγεται στα 25 μέτρα με πιστόλι διαμετρήματος από 0,30 έως 0,38 ίντσες (7,62–9,65 mm). Περιλαμβάνει 60 βολές, χωρισμένες σε δύο στάδια των 30 βολών, το Στάδιο Ακριβείας και το Στάδιο Ταχύτητας. Είναι ουσιαστικά ταυτόσημο με το Πιστόλι Σπορ, με μόνη διαφορά το διαμέτρημα του όπλου.",
      },
    ],
  },
  {
    title: "Τυφέκιο ISSF",
    label: "Κατά σειρά διαμετρήματος",
    disciplines: [
      {
        title: "Τυφέκιο Πρηνηδόν 50μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["50 μέτρα", ".22 Long Rifle", "60 βολές"],
        description:
          "Ο αθλητής εκτελεί 60 έγκυρες βολές από πρηνή (ξαπλωτή) θέση, σε απόσταση 50 μέτρων, με τυφέκιο διαμετρήματος .22 Long Rifle. Ο χρόνος του αγώνα είναι 50 λεπτά (60 λεπτά με χάρτινους στόχους), μετά από 15 λεπτά προετοιμασίας και δοκιμαστικών βολών.",
      },
      {
        title: "Τυφέκιο Τριών Στάσεων 50μ.",
        calibre: "Μικρού διαμετρήματος",
        facts: ["50 μέτρα", ".22 LR", "Ολυμπιακό"],
        description:
          "Ο σκοπευτής εκτελεί 60 βολές συνολικά (3×20) με τυφέκιο .22 LR, σε απόσταση 50 μέτρων. Ο αγώνας χωρίζεται σε τρεις στάσεις, με σειρά γονυπετώς, πρηνηδόν και ορθίως, και ολοκληρώνεται σε συνολικό χρόνο 1 ώρας και 30 λεπτών. Πρόκειται για ολυμπιακό αγώνισμα.",
      },
      {
        title: "Τυφέκιο Πρηνηδόν 300μ.",
        calibre: "Μεγάλου διαμετρήματος",
        facts: ["300 μέτρα", "Έως 8 mm", "60 βολές"],
        description:
          "Ένα παραδοσιακό και ιδιαίτερα απαιτητικό αγώνισμα. Οι σκοπευτές εκτελούν 60 βολές από πρηνή θέση, σε στόχο που απέχει 300 μέτρα, χρησιμοποιώντας ραβδωτά τυφέκια κεντρικής πυροδότησης διαμετρήματος έως 8 mm.",
      },
      {
        title: "Τυφέκιο Στάνταρ 300μ. 3×20",
        calibre: "Μεγάλου διαμετρήματος",
        facts: ["300 μέτρα", "3 στάσεις", "60 βολές"],
        description:
          "Απαιτητικό αγώνισμα σταθερού στόχου, στο οποίο οι αθλητές εκτελούν 60 βολές συνολικά από απόσταση 300 μέτρων, μοιρασμένες ισόποσα σε τρεις στάσεις: γονυπετώς, πρηνηδόν και ορθίως, με τυφέκιο τύπου στάνταρ.",
      },
    ],
  },
];

export const contact = {
  facebook: "https://www.facebook.com/omega.shooting",
  email: "info@skopovoli.gr",
  phone: "+30 6909152733",
};

export const routeMetadata: Record<string, { title: string; description: string; label: string; keywords: string[] }> = {
  "/": {
    title: "ΑΣΟ Ωμέγα | Αθλητικός Σκοπευτικός Όμιλος",
    description: hero.text,
    label: "Αρχική",
    keywords: [
      "Αθλητικός Σύλλογος Σκοποβολής",
      "Αθλητικός Σύλλογος Όμιλος",
      "Σκοποβολή σταθερού στόχου",
      "Προπόνηση σκοποβολής",
      "Σκοπευτήριο Αθήνα",
      "Shooting sport",
    ],
  },
  "/o-syllogos": {
    title: "Ο Σύλλογος | ΑΣΟ Ωμέγα",
    description: aboutParagraphs[0],
    label: "Ο Σύλλογος",
    keywords: ["Αθλητικός Σύλλογος Σκοποβολής", "Αθλητικός Σύλλογος Όμιλος", "Shooting sport"],
  },
  "/to-athlima": {
    title: "Το Άθλημα | ΑΣΟ Ωμέγα",
    description: "Τα αγωνίσματα ISSF στα οποία προπονείται ο ΑΣΟ Ωμέγα.",
    label: "Το Άθλημα",
    keywords: ["ISSF", "ΣΚΟΕ", "Σκοποβολή σταθερού στόχου", "Πιστόλι ISSF", "Τυφέκιο ISSF"],
  },
  "/topothesies": {
    title: "Τοποθεσίες | ΑΣΟ Ωμέγα",
    description: "Πεδίο Βολής και Γραφεία Συλλόγου του ΑΣΟ Ωμέγα.",
    label: "Τοποθεσίες",
    keywords: ["Σκοπευτήριο Αθήνα", "Shooting range", "Προπόνηση σκοποβολής", "Ηλιούπολη"],
  },
  "/ekpaideftes": {
    title: "Εκπαιδευτές | ΑΣΟ Ωμέγα",
    description: aboutParagraphs[3],
    label: "Εκπαιδευτές",
    keywords: [
      "Μαθήματα σκοποβολής",
      "Shooting training",
      "Ασφαλής χειρισμός όπλων",
      "Σχολή σκοποβολής",
      "Μαθήματα σκοποβολής για αρχάριους και προχωρημένους",
    ],
  },
  "/erotiseis": {
    title: "Ερωτήσεις | ΑΣΟ Ωμέγα",
    description: "Συχνές ερωτήσεις για την εγγραφή και την προπόνηση στον ΑΣΟ Ωμέγα.",
    label: "Ερωτήσεις",
    keywords: ["πώς να μάθω σκοποβολή", "δοκιμή σκοποβολής", "Μαθήματα σκοποβολής", "Σχολή σκοποβολής"],
  },
  "/epikoinonia": {
    title: "Επικοινωνία | ΑΣΟ Ωμέγα",
    description: "Επικοινωνήστε με τον ΑΣΟ Ωμέγα.",
    label: "Επικοινωνία",
    keywords: ["Μαθήματα σκοποβολής", "Προπόνηση σκοποβολής", "δοκιμή σκοποβολής", "Σκοπευτήριο Αθήνα"],
  },
  "/eggrafa": {
    title: "Έγγραφα | ΑΣΟ Ωμέγα",
    description: "Έγγραφα και αιτήσεις του ΑΣΟ Ωμέγα για λήψη.",
    label: "Έγγραφα",
    keywords: ["έγγραφα", "αιτήσεις", "ΣΚΟΕ", "ΑΣΟ Ωμέγα"],
  },
};
